import React from 'react'
import EightPlusPagination from './eight-plus-pagination'
import SevenOrLessPagination from './seven-or-less-pagination'

const PaginationComponent = ({ totalPages = 0, currentPage = 0, setCurrentPage = () => {} }) => {
    if (totalPages <= 1) {
        return null
    }
    if (totalPages <= 7) {
        return (<SevenOrLessPagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />)
    }
    return (<EightPlusPagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />)
}

export default PaginationComponent